import React from 'react';
import ProjectPopupBody from './project-popup-body';
import classnames from 'classnames';

class ProjectPopup extends React.Component {
  

  render(){
    const { features, onMouseOut, onMouseOver, onItemClick, hidden } = this.props;
    const popupClass = classnames({
      "panel": true,
      "panel-default": true,
      "top": true,
      "clearfix": true,
      "hidden": hidden
    })
    return (
      <div onMouseOver={onMouseOver} onMouseOut={onMouseOut} className={popupClass} style={{marginBottom:0}}>
        <div className="arrow" style={{left: '50%'}}></div>
        <div className="panel-body" style={{paddingTop: 10, paddingLeft: 10, paddingRight: 10, paddingBottom: 0}}>
          {
            features.map((f, i) => {
              return <ProjectPopupBody key={i} feature={f} onItemClick={onItemClick}/>
            })
          }
        </div>
      </div>
    )
  }
}

export default ProjectPopup